import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

import { useAudioTabContext } from "./audio-tab-context";

const cmsAudioTabHeaderFormSchema = z.object({
  title: z.string(),
  description: z.string(),
});

export const AudioTabHeader = () => {
  const { options, onUpdateOptions } = useAudioTabContext();

  const form = useForm({
    resolver: zodResolver(cmsAudioTabHeaderFormSchema),
    defaultValues: {
      title: options.title,
      description: options.description,
    },
  });

  const onSubmit = (data: z.infer<typeof cmsAudioTabHeaderFormSchema>) => {
    onUpdateOptions({
      ...options,
      title: data.title,
      description: data.description,
    });
  };

  return (
    <Card>
      <CardHeader>
        <h4 className="text-lg font-medium leading-none">Header</h4>
      </CardHeader>

      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <CardContent className="space-y-4">
            <FormField
              control={form.control}
              name="title"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Title</FormLabel>
                  <FormControl>
                    <Input placeholder="Add a title to your tab" {...field} />
                  </FormControl>
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="description"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Description</FormLabel>
                  <FormControl>
                    <Textarea
                      placeholder="Add a description to give more context to your tab"
                      {...field}
                    />
                  </FormControl>
                </FormItem>
              )}
            />
          </CardContent>

          <div className="border-t px-6 py-4">
            <Button type="submit">Save</Button>
          </div>
        </form>
      </Form>
    </Card>
  );
};
